import { __assign, __rest } from "tslib";
import React from 'react';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import { TopNavigationLogoContainer } from './TopNavigationLogoContainer';
import { Logo } from '../Logo/Logo';
/*
 * Styles
 */
var useStyles = makeStyles(function (theme) { return ({
    root: function (_a) {
        var position = _a.position, isMobile = _a.isMobile;
        return ({
            position: position,
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
            width: '100%',
            height: isMobile ? theme.spacing(6.25) : theme.spacing(8.5),
            zIndex: 10,
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: theme.palette.common.white,
        });
    },
}); });
/**
 * Top navigation component
 */
export var TopNavigation = function (_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'fixed' : _b, className = _a.className;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    var classes = useStyles({
        position: position,
        isMobile: isMobile,
    });
    return React.createElement("nav", { className: clsx(classes.root, className) }, children);
};
/**
 * Default LeasePlan Top Navigation.
 */
export var LeasePlanTopNavigation = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var isAboveTablet = useMediaQuery(function (theme) {
        return theme.breakpoints.up('md');
    });
    return (React.createElement(TopNavigation, __assign({}, props),
        React.createElement(TopNavigation.LogoContainer, null,
            React.createElement(Logo, { type: isAboveTablet ? 'expanded' : 'collapsed' })),
        children));
};
TopNavigation.LogoContainer = TopNavigationLogoContainer;
//# sourceMappingURL=TopNavigation.js.map